import React from 'react';
import { Button as UIButton } from './ui/button';
import { Loader2 } from 'lucide-react';

/**
 * Standardized button variants with CharterShare brand colors
 * Brand Blue: #007AFF (used consistently across all primary actions)
 */

// Primary Button (Main actions - CharterShare Blue)
export const PrimaryButton = ({ children, loading, disabled, className = '', size, ...props }) => (
  <UIButton
    style={{ background: disabled ? undefined : '#007AFF' }}
    className={`hover:opacity-90 text-white ${size !== 'lg' ? 'h-9' : ''} ${className}`}
    disabled={disabled || loading}
    size={size}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);

// Secondary Button (Less important actions)
export const SecondaryButton = ({ children, loading, disabled, className = '', size, ...props }) => (
  <UIButton
    variant="outline"
    disabled={disabled || loading}
    className={`${size !== 'lg' ? 'h-9' : ''} ${className}`}
    size={size}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);

// Success Button (Positive actions - save, confirm, submit)
export const SuccessButton = ({ children, loading, disabled, className = '', size, ...props }) => (
  <UIButton
    className={`bg-green-600 hover:bg-green-700 text-white ${size !== 'lg' ? 'h-9' : ''} ${className}`}
    disabled={disabled || loading}
    size={size}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);

// Danger Button (Destructive actions - delete)
export const DangerButton = ({ children, loading, disabled, className = '', size, ...props }) => (
  <UIButton
    className={`bg-red-600 hover:bg-red-700 text-white ${size !== 'lg' ? 'h-9' : ''} ${className}`}
    disabled={disabled || loading}
    size={size}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);

// Warning Button (Caution actions)
export const WarningButton = ({ children, loading, disabled, className = '', ...props }) => (
  <UIButton
    className={`bg-orange-600 hover:bg-orange-700 text-white ${className}`}
    disabled={disabled || loading}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);

// Ghost Button (Minimal actions)
export const GhostButton = ({ children, loading, disabled, className = '', ...props }) => (
  <UIButton
    variant="ghost"
    disabled={disabled || loading}
    className={className}
    {...props}
  >
    {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
    {children}
  </UIButton>
);
